import React, { Component } from 'react';
import '../css/Pagination.css';

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state={
            lengths: this.props.lengths,
            currentPage: 1,
            rowPerPage: this.props.rowPerPage
        }
    }

    changePage = (e) => {
        this.props.onSelectPage(e);
        this.setState({ currentPage: e });
    }

    goFirst = () => {
        this.props.onSelectPage(1);
        this.setState({ currentPage: 1 });
    }

    goLast = () => {
        const { lengths, rowPerPage } = this.state;
        this.props.onSelectPage(Math.ceil(lengths / rowPerPage));
        this.setState({ currentPage: Math.ceil(lengths / rowPerPage) });
    }

    render() {
        const { currentPage, lengths, rowPerPage } = this.state;
        let limitLoop = 3;
        let start = 1;
        if ( Math.ceil(lengths / rowPerPage) < 3 ) {
            start = (currentPage < 2) ? currentPage : (currentPage - 1);
            limitLoop = Math.ceil(lengths / rowPerPage);
        } else {
            if ( currentPage === Math.ceil(lengths / rowPerPage) ) {
                start = (currentPage - 2);
            } else if ( currentPage > 1) {
                start = (currentPage - 1);
            }
        }

        const pageNumbers = [];
        for (let i = 0; i < limitLoop; i++) {
          pageNumbers.push(start);
          start++;
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <li key={number} id={number} onClick={(e) => this.changePage(number)} className={(number === this.state.currentPage) ? "pag-active" : ""}><a className="page-link-a" href="javascript:void(0)">{number}</a></li>
            );
        });
        return(
            <div>
                <ul className="pagination-content">
                    <li>
                        <a className="page-link-a pag-prev" href="javascript:void(0)" aria-label="Previous" onClick={(e) => this.goFirst()}>
                            <span aria-hidden="true">&laquo;</span><span className="sr-only">Previous</span>
                        </a>
                    </li>
                    {renderPageNumbers}
                    <li>
                        <a className="page-link-a pag-next" href="javascript:void(0)" aria-label="Next" onClick={(e) => this.goLast()}>
                            <span aria-hidden="true">&raquo;</span><span className="sr-only">Next</span>
                        </a>
                    </li>
                </ul>
            </div>
        )
    }
}

export default Pagination;